import { connect } from 'react-redux'
import { IStoreState } from '../../types/index'
import RemoveColorModal from 'src/components/global-settings/RemoveColorModal'
import { removeVehicleColor, getVehicleCreateOptions } from 'src/state/actions/vehicles'
import { getVehicleColor } from 'src/state/selectors'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    id: ownProps.match.params.id,
    setting: getVehicleColor(ownProps.match.params.id, state)
  }
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    removeVehicleColor: (id: string) => {
      return new Promise((approve, reject) => {
        dispatch(removeVehicleColor(id)).then(() => {
          dispatch(getVehicleCreateOptions()).then(() => {
            approve()
          })
        })
      })
    },
    getVehicleCreateOptions: () => dispatch(getVehicleCreateOptions())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RemoveColorModal)



// WEBPACK FOOTER //
// ./src/containers/global-settings/RemoveColorModal.ts